import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconOneNumberProps } from './IconOneNumber.types'
import * as Styled from './styles/IconOneNumber.style'

import { nonThemeableRules } from '../../ruleSet'

const IconOneNumber: FC<IconOneNumberProps> = ({
  size = nonThemeableRules.defaultSize as number as IconOneNumberProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconOneNumberProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M147.54 116.94C136.76 133 96 172 96 172V70.61a5 5 0 0 0-5-5h-8.53a5.21 5.21 0 0 0-2.68.77L56.42 81.17A5 5 0 0 0 54.81 88l3.75 6.14a5 5 0 0 0 6.87 1.67h.07L76.33 89v52.2a62.14 62.14 0 1 1 71.24-24.2Z'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconOneNumber
